/**
 * Utilities.
 */
function AdsNinjaUtils(){

}

/**
 * Rounds a number up to two decimals.
 * 
 * @param {number} number 
 * @returns {number}
 */
AdsNinjaUtils.prototype.roundUpToTwoDecimalPoints = function(number){
    
    if(!number || Number.isNaN(number)){
        
        return 0;
    }

    return (Number.isInteger(number)) ? number : Math.ceil(Number(number * 100).toFixed(2)) / 100;
};

/**
 * Rounds a number down to two decimals.
 * 
 * @param {number} number 
 * @returns {number}
 */
AdsNinjaUtils.prototype.roundDownToTwoDecimalPoints = function(number){
    
    if(!number || Number.isNaN(number)){
        
        return 0;
    }

    return (Number.isInteger(number)) ? number : Math.floor(Number(number * 100).toFixed(2)) / 100;
};

/**
 * Rounds a number to two decimals.
 * 
 * @param {number} number 
 * @returns {number}
 */
AdsNinjaUtils.prototype.roundToTwoDecimalPoints = function(number){
    
    if(!number || Number.isNaN(number)){
        
        return 0;
    }

    return (Number.isInteger(number)) ? number : Math.round(number * 100) / 100;
};

window.AdsNinjaUtils = AdsNinjaUtils;